import React from 'react';


export const StageDispute = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Primary Dispute Resolution Method</label>
              <p className="text-xs text-white/40 mb-3">For major disputes, after 3 good faith discussions without resolution, what process should be used?</p>
              <div className="space-y-2">
                {[
                  { id: 'mediation-first', name: 'Mediation First', desc: 'Attempt mediation before filing with the court' },
                  { id: 'collaborative', name: 'Collaborative Process', desc: 'Use collaborative professionals to resolve disputes' },
                  { id: 'parenting-coordinator', name: 'Parenting Coordinator', desc: 'Appoint a parenting coordinator for ongoing disputes' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('disputeProcess', opt.id); }}
                      data-testid={'dispute-' + opt.id}
                      className={planData.disputeProcess === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#3B82F6] bg-[#3B82F6]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">How Many Mediation Sessions Required for Major Disputes?</label>
              <p className="text-xs text-white/40 mb-3">After 3 good faith discussions without resolution, how many mediation sessions must take place before court action?</p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {[
                  { id: '1', label: '1 Session' },
                  { id: '2', label: '2 Sessions' },
                  { id: '3', label: '3 Sessions' },
                  { id: '4', label: '4 Sessions' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('mediationSessions', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.mediationSessions === opt.id ? 'border-[#3B82F6] bg-[#3B82F6]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'mediation-sessions-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Mediation / Resolution Costs</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'equal', label: 'Split Equally' },
                  { id: 'proportional', label: 'Proportional to Income' },
                  { id: 'plaintiff', label: 'Plaintiff Pays' },
                  { id: 'defendant', label: 'Defendant Pays' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('mediationCost', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.mediationCost === opt.id ? 'border-[#3B82F6] bg-[#3B82F6]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Plan Modification Process</label>
              <div className="space-y-2">
                {[
                  { id: 'mediation-required', name: 'Mediation Required Prior to Court Action', desc: 'Both parties must attempt mediation before bringing any modification to court' },
                  { id: 'mediation-unless-po', name: 'Mediation Required Unless Protective Order in Place', desc: 'Mediation is required prior to court action, unless an active protective order exists between the parties' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('modificationProcess', opt.id); }}
                      className={planData.modificationProcess === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#3B82F6] bg-[#3B82F6]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}
                      data-testid={'modification-' + opt.id}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="card-surface p-5 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Plan Review Milestones</label>
                <p className="text-xs text-white/40 mb-3">Should the plan have mandatory review points at key milestones in the child&apos;s life?</p>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { id: 'yes', label: 'Yes — Set Milestones' },
                    { id: 'no', label: 'No — Review As Needed' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('reviewMilestones', opt.id); }}
                        className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                          (planData.reviewMilestones === opt.id ? 'border-[#3B82F6] bg-[#3B82F6]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid={'review-milestones-' + opt.id}>
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {planData.reviewMilestones === 'yes' && (
                <div>
                  <label className="block text-sm font-medium mb-2">Select Review Milestones</label>
                  <p className="text-xs text-white/40 mb-3">Choose all milestones that should trigger a mandatory plan review:</p>
                  <div className="space-y-2">
                    {[
                      { id: 'elementary-complete', label: 'Completion of Elementary School' },
                      { id: 'middle-complete', label: 'Completion of Middle School' },
                      { id: 'halfway-highschool', label: 'Halfway Through High School' },
                      { id: 'iep-placed', label: 'Child Is Placed on an IEP' },
                      { id: 'significant-injury', label: 'Child Becomes Significantly Injured or Disabled' },
                      { id: 'ada-diagnosis', label: 'Child Is Diagnosed with a Condition Qualifying as a Disability Under the ADA' },
                    ].map(function(opt) {
                      var selected = planData.reviewMilestonesList.includes(opt.id);
                      return (
                        <button key={opt.id} onClick={function() {
                          var arr = planData.reviewMilestonesList.slice();
                          if (selected) {
                            arr = arr.filter(function(v) { return v !== opt.id; });
                          } else {
                            arr.push(opt.id);
                          }
                          updateData('reviewMilestonesList', arr);
                        }}
                          className={'w-full flex items-center gap-3 p-3 rounded-lg border text-left transition-all ' +
                            (selected ? 'border-[#3B82F6] bg-[#3B82F6]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'milestone-' + opt.id}>
                          <div className={'w-5 h-5 rounded-md border-2 flex items-center justify-center flex-shrink-0 ' +
                            (selected ? 'border-[#3B82F6] bg-[#3B82F6]' : 'border-white/20')}>
                            {selected && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>}
                          </div>
                          <span className="text-sm">{opt.label}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        
  );
};
